import { getLocalDevHeaders } from "../auth/localDevelopment";

export class AuthorizedApiBase {
  private authToken: string | undefined;

  constructor() {}

  protected transformOptions = (options: RequestInit): Promise<RequestInit> => {
    if (!this.authToken) {
      throw new Error("No authentication information provided");
    }

    const localDevHeaders = getLocalDevHeaders();

    options.headers = {
      ...options.headers,
      ...localDevHeaders,
      Authorization: this.authToken ? `Bearer ${this.authToken}` : "",
    };

    return Promise.resolve(options);
  };

  public setAuthToken = (authToken: string) => {
    this.authToken = authToken;
  };
}
